<div class="slide-menu position-fixed top-0 start-0 w-100 vh-100" (click)="slideMenuService.showed = false">
  <div class="slide-menu__panel d-flex flex-column overflow-hidden h-100" (click)="$event.stopPropagation()">

    <div class="slide-menu__header d-flex align-items-center justify-content-between flex-shrink-0">
      <div class="d-flex align-items-center gap-3">
        <div class="slide-menu__logo d-flex align-items-center justify-content-center">
          <i class="material-icons">build</i>
        </div>
        <span class="slide-menu__brand-text fw-bold">MechanicApp</span>
      </div>
      <button class="slide-menu__close d-flex align-items-center justify-content-center rounded-circle border-0" (click)="slideMenuService.showed = false">
        <i class="material-icons">close</i>
      </button>
    </div>

    <nav class="slide-menu__nav flex-grow-1 overflow-auto">
      @for (menu of menuData; track $index) {
        <app-menu-item [menuItem]="menu"></app-menu-item>
      }
    </nav>

  </div>
</div>
